export const trimAndLowerCase = (value) => {
   let string = value.replace(/\s/g, "").toLowerCase();
   return string.replace(/[^a-zA-Z0-9]/g,'_')
};
